export default {"src":"/_next/static/media/lpt.45d3c0fe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};